import { m, AnimatePresence } from 'framer-motion';
// @mui
import { alpha } from '@mui/material/styles';
import { List, IconButton, ListItemText, ListItem, LinearProgress, Box } from '@mui/material';
// utils
import { fData } from '../../utils/formatNumber';
import getFileData from '../../utils/getFileData';
// type
import { UploadMultiFileProps } from './type';
//
import Image from '../Image';
import Iconify from '../Iconify';
import { varFade } from '../animate';
import { Typography } from '@mui/material';
import { useEffect, useState } from 'react';

import FileUploadStatus from './FileUploadStatus';

// ----------------------------------------------------------------------

export default function MultiFilePreview({
  showPreview = false,
  files,
  onRemove,
  showProgress,
  fileProgress,
  handleUploadedFile,
  isUploading,
}: UploadMultiFileProps) {
  const hasFile = files.length > 0;


  const [uploadedFiles, setUploadedFiles] = useState<(any)[]>([]);

  
  const getUploadedFile = (file:any, fileName:any) => {
    let uploaded = files.find((item: any) => item.path === fileName)
    // if (onRemove) {
    //   onRemove(file);
    // }
    if (handleUploadedFile) {
      handleUploadedFile(file);
    }

  };


  return (
    <List disablePadding sx={{ ...(hasFile && { my: 3, maxHeight: 300,
      overflowY : 'scroll', background: '#161c24', p:1, m:0 }) }}>
      <AnimatePresence>
        {files.map((file, index) => {
          const { key, name, size, preview, progress } = getFileData(file, index);
          let fileName:any = name;
          
          if (showPreview) {
            return (
              <ListItem
                key={key}
                component={m.div}
                // {...varFade().inRight}
                sx={{
                  p: 0,
                  m: 0.5,
                  width: 80,
                  height: 80,
                  borderRadius: 1.25,
                  overflow: 'hidden',
                  position: 'relative',
                  display: 'inline-flex',
                  border: (theme) => `solid 1px ${theme.palette.divider}`,
                }}
              >
                <Image alt="preview" src={preview} ratio="1/1" />
                {
                  (showProgress && 10 < 100 ) && (
                    <LinearProgress
                      variant="determinate"
                      value={70}
                      sx={{
                        '& .MuiLinearProgress-bar': { bgcolor: 'primary' },
                        '&.MuiLinearProgress-determinate': { bgcolor: 'grey.900' },
                        width: '100%',
                        position: 'absolute',
                        bottom:10

                      }}
                    />
                  )
                }

                {onRemove && (
                  <IconButton
                    size="small"
                    onClick={() => onRemove(file)}
                    sx={{
                      top: 6,
                      p: '2px',
                      right: 6,
                      position: 'absolute',
                      color: 'common.white',
                      bgcolor: (theme) => alpha(theme.palette.grey[900], 0.72),
                      '&:hover': {
                        bgcolor: (theme) => alpha(theme.palette.grey[900], 0.48),
                      },
                    }}
                  >
                    <Iconify icon={'eva:close-fill'} />
                  </IconButton>
                )}
              </ListItem>
            );
          }

          return (
            <ListItem
              key={index}
              component={m.div}
              // {...varFade().inRight}
              sx={{
                my: 1,
                px: 2,
                py: 0.75,
                borderRadius: 0.75,
                border: (theme) => `solid 1px ${theme.palette.divider}`,
              }}
            >
              <Iconify
                icon={'eva:file-fill'}
                sx={{ width: 28, height: 28, color: 'text.secondary', mr: 2 }}
              />

              <ListItemText
                primary={typeof file === 'string' ? file : name?.slice(0,30)}
                secondary={typeof file === 'string' ? '' : fData(size || 0)}
                primaryTypographyProps={{ variant: 'subtitle2' }}
                secondaryTypographyProps={{ variant: 'caption' }}
              />

              {onRemove && <FileUploadStatus isUploading={isUploading} progress={progress} onRemove={onRemove} file={file}  /> }
              </ListItem>
          );
        })}
      </AnimatePresence>
    </List>
  );
}
